import { render, staticRenderFns } from "./IconShoppingBagOutline.vue?vue&type=template&id=02a980ab"
import script from "./IconShoppingBagOutline.vue?vue&type=script&lang=js"
export * from "./IconShoppingBagOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports